import mainRouting from './mainRouting/mainRouting';
import errorPage from './errorPage/errorPage';
import authentication from './authentication/authentication';
import notAllowed from './notAllowed/notAllowed';

let features = angular.module('features', [
  mainRouting, errorPage, authentication, notAllowed
])

  .name;

export default features;



// WEBPACK FOOTER //
// ./client/app/features/features.js